import styled from 'styled-components'

export const InventorySelectedItemStyled = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px;
    box-shadow: 0px 0.71px 0.64px -0.15px rgba(0, 0, 0, 0.02), 0px 1.93px 1.74px -0.3px rgba(0, 0, 0, 0.02065),
        0px 4.25px 3.82px -0.44px rgba(0, 0, 0, 0.0274), 0px 9.43px 8.49px -0.6px rgba(0, 0, 0, 0.04253),
        0px 24px 21.59px -0.75px rgba(0, 0, 0, 0.085);
    background-color: #fff;
    height: 100%;
    max-height: 425px;
    overflow: visible;
    position: relative;
    align-content: center;
    flex-wrap: nowrap;
    gap: 10px;
    border-radius: 12px;

    > div {
        height: 100%;

        &:nth-child(2) {
            min-height: 350px;
            min-width: 350px;
        }
    }

    object,
    video,
    img {
        height: 353px;
        border-radius: 12px;
    }
`

export const InventorySelectedItemTitle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    width: 100%;
    line-height: 1.2;

    > div {
        &:first-child {
            font-weight: bold;
        }
    }
`
